import { t } from "../../../utils/i18n";
import React, { useState } from "react";
import { maskCardNumber } from "../Details/Card/helpers";

interface Card {
  id: string;
  card_number: string;
  card_type: string;
  status: string;
  first_name: string;
  last_name: string;
}

interface CardSelectorProps {
  cards: Card[];
  currentCardId: string;
  onCardChange: (cardId: string) => void;
}

export default function CardSelector({
  cards,
  currentCardId,
  onCardChange,
}: CardSelectorProps) {
  const [selectedCardId, setSelectedCardId] = useState(currentCardId);

  const handleCardChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const cardId = e.target.value;
    setSelectedCardId(cardId);
    onCardChange(cardId);
  };

  // If there's only one card, don't show the selector
  if (cards.length <= 1) {
    return null;
  }

  return (
    <div className="card-selector-container mb-4">
      <div className="card shadow-sm rounded-lg">
        <div className="card-body">
          <div className="form-group">
            <label htmlFor="cardSelector" className="font-weight-bold">
              {t("cards.common.select_card")}
            </label>
            <select
              id="cardSelector"
              className="form-control"
              value={selectedCardId}
              onChange={handleCardChange}
              style={{ minWidth: "280px" }}
            >
              {cards.map((card) => (
                <option key={card.id} value={card.id}>
                  {card.card_type} - {maskCardNumber(card.card_number)}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}